import React, { ReactElement } from 'react';
import { ITealiumConfig } from '../../../utils/models';
import { Link } from 'gatsby';

import './ButtonLink.scss';

// TEALIUM
import initTealiumTracker from 'tealium-tracker';
import { KiteIcon } from '@kite/react-kite';
let tealiumTrackEvent;
if (typeof window !== 'undefined') {
  const { trackEvent } = initTealiumTracker({ debugMode: true });
  tealiumTrackEvent = trackEvent;
}

export interface IButtonLinkProps {
  type: 'primary' | 'secondary' | 'transparent';
  path: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
  tabIndex?: number;
  className?: string;
  children: ReactElement | string;
  rel?: string;
  target?: string;
  onClick?: () => void;
  tealiumConfig?: ITealiumConfig;
  gatsbyLink?: boolean;
  leftIcon?: string;
  rightIcon?: string;
}

const ButtonLink = ({
  type,
  path,
  ariaHidden = false,
  ariaLabel = '',
  tabIndex = 0,
  className = '',
  children,
  rel = '',
  target = '',
  onClick,
  tealiumConfig,
  gatsbyLink,
  leftIcon,
  rightIcon,
}: IButtonLinkProps) => {
  const handleClick = () => {
    if (
      tealiumConfig &&
      tealiumConfig.dataLinkName &&
      tealiumConfig.dataLinkType
    ) {
      tealiumTrackEvent({
        linktype: tealiumConfig.dataLinkType,
        linkname: tealiumConfig.dataLinkName,
      });
    }
    onClick && onClick();
  };

  if (gatsbyLink) {
    return (
      <Link
        className={`button-link button-link--${type} ${className}`}
        to={path}
        onClick={handleClick}
      >
        {leftIcon && (
          <KiteIcon
            id="button-link-left-icon"
            className="button-link__left-icon"
            icon={leftIcon}
          />
        )}
        {children}
        {rightIcon && (
          <KiteIcon
            id="button-link-right-icon"
            className="button-link__right-icon"
            icon={rightIcon}
          />
        )}
      </Link>
    );
  }

  if (!tealiumConfig) {
    return (
      <a
        aria-hidden={ariaHidden}
        aria-label={ariaLabel}
        tabIndex={tabIndex}
        href={path}
        className={`button-link button-link--${type} ${className}`}
        rel={rel}
        target={target}
        onClick={handleClick}
      >
        {leftIcon && (
          <KiteIcon
            id="button-link-left-icon"
            className="button-link__left-icon"
            icon={leftIcon}
          />
        )}
        {children}
        {rightIcon && (
          <KiteIcon
            id="button-link-right-icon"
            className="button-link__right-icon"
            icon={rightIcon}
          />
        )}
      </a>
    );
  }

  return (
    <a
      aria-hidden={ariaHidden}
      tabIndex={tabIndex}
      href={path}
      className={`button-link button-link--${type} ${className}`}
      rel={rel}
      target={target}
      onClick={handleClick}
      data-linktype={tealiumConfig && tealiumConfig.dataLinkType}
      data-linkname={tealiumConfig && tealiumConfig.dataLinkName}
    >
      {leftIcon && (
        <KiteIcon
          id="button-link-left-icon"
          className="button-link__left-icon"
          icon={leftIcon}
        />
      )}
      {children}
      {rightIcon && (
        <KiteIcon
          id="button-link-right-icon"
          className="button-link__right-icon"
          icon={rightIcon}
        />
      )}
    </a>
  );
};

export default ButtonLink;
